<script>
import bem from '@/utils/bem';
import { mapActions, mapGetters } from 'vuex';
import ArtFrame from '@/components/modals/Art-frame.vue';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons-vue';

const b = bem('template-collection-frame');

export default {
  components: {
    ArtFrame,
    PlusOutlined,
    DeleteOutlined,
  },
  data() {
    return {
      show: false,
      frames: [],
      isNew: false,
      selectedFrame: {},
    };
  },
  props: {
    selectedCollection: {
      type: Object,
      required: true,
    },
    selectedFrameId: {
      type: Number,
      required: true,
    },
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    selectFrame(value) {
      this.getFrameOptionsAction({
        id: value.id,
        type: value.name,
      });
      if (!value.productCollectionId) {
        this.$emit('update:selectedFrameId', value.id);
      }
      this.getFrameDetailsAction(value.id);
      this.getFrameSizesAction();
      this.getFrameColorsAction();
    },
    toggleShow(value, frame, isNew) {
      this.show = value;
      this.selectedFrame = {
        ...frame,
        customInfo: frame.customInfo ? JSON.parse(frame.customInfo) : {},
      };
      this.isNew = isNew;
    },
    onDelete(id, name) {
      this.deleteTemplateFrameAction({
        id,
        name,
      });
    },
    ...mapActions({
      getFrameOptionsAction: 'createTemplate/getFrameOptions',
      getFrameSizesAction: 'createTemplate/getFrameSizes',
      getFrameColorsAction: 'createTemplate/getFrameColors',
      deleteTemplateFrameAction: 'createTemplate/deleteTemplateFrame',
      getFrameDetailsAction: 'createTemplate/getFrameDetails',
    }),
  },
  computed: {
    ...mapGetters({
      getFrames: 'createTemplate/getTemplateFrames',
    }),
  },
};
</script>

<template>
  <div :class="b('')">
    <div :class="b('header')">
      <h3 :class="b('title')">{{ selectedCollection.name }} frames</h3>
      <a-button
        :class="b('new-frame-btn')"
        type="primary"
        @click.stop="toggleShow(true, {}, true)"
      >
        <template #icon><plus-outlined /></template>
        Create new frame
      </a-button>
    </div>

    <div :class="b('grid')">
      <div
        v-for="frame in getFrames(selectedCollection.id) || []"
        :key="frame.id"
        :class="b('card', { selected: selectedFrameId === frame.id })"
        :style="{ order: frame.order }"
        tabindex="0"
        role="button"
        @click.stop="selectFrame(frame)"
        @keydown.enter="selectFrame(frame)"
      >
        <div :class="b('card-image-wrap')">
          <img
            :class="b('card-image')"
            :src="frame.imageUri"
            :alt="frame.displayName"
          />
          <span v-if="frame.isDefault" :class="b('card-badge')">Default</span>
        </div>
        <div :class="b('card-content')">
          <span :class="b('card-title')">{{ frame.displayName }}</span>
          <span :class="b('card-type')">{{ frame.name === 'collage' ? 'Collage' : 'Frame' }}</span>
        </div>
        <div :class="b('card-actions')">
          <a-popconfirm
            title="Are you sure you want to delete this frame?"
            ok-text="Yes"
            cancel-text="No"
            @confirm="onDelete(frame.id, frame.name)"
          >
            <a-button
              :class="b('delete-btn')"
              type="text"
              danger
              size="small"
              @click.stop
            >
              <template #icon><delete-outlined /></template>
            </a-button>
          </a-popconfirm>
        </div>
      </div>
    </div>

    <template v-if="show">
      <ArtFrame
        v-model:show="show"
        :frame="selectedFrame"
        :is-new="isNew"
        :frame-material-id="selectedCollection.id"
      />
    </template>
  </div>
</template>

<style scoped lang="scss" src="./templateCollectionFrames.scss"></style>
